import axios from 'axios';
import config from '../config/config';
import helper from './helper';

export default function loginService() {

    // const validateUser = (userName, token, rnd) => {

    //     var baseUrl = config.baseUrl + 't3logins/mapi';
    //     return axios.get(baseUrl + `/login/validatenew/${userName}/token/${token}/${rnd}`).then(response => {

    //         if (response.data.success) {
    //             var user = response.data;
    //             user.token = token;
    //             user.rnd = rnd;

    //             var jsValue = JSON.stringify(user);
    //             //if (rememberMe) {
    //             //save login infos on cookie if user clicked rememberMe for 4 days     
    //             let rememberMe = helper().getItem('rememberMe');        
    //             var exdays = (rememberMe) ? 4 : 0;

    //             helper().setItem('logedInUser', jsValue, exdays);               
    //             window.location = '/shops/';
    //             //window.location = '/shops/';
    //         }
    //         return response.data;
    //     });
    // }

    const useAuthCode = (authCode) => {

        var baseUrl = config.baseUrl + 't3logins/mapi';
        return axios.get(baseUrl + `/login/useauthcode/${authCode}`).then(response => {
            //response : {"success":true,"data":[{"id":5,"username":"arsim","firstname":"Arsim","lastname":"Syla","token":"1231231","rnd":111}]}
            return response.data;
        });
    }
    
    const logout = () => {
        //delete cokie if any
        helper().deleteItem('logedInUser');        
        helper().deleteItem('settings');
        helper().deleteItem('userSettings');
        helper().deleteItem('rememberMe');
       
        window.location = config.homepage;
    }

    return {
        //login: login,
        logout: logout,
        //validateUser: validateUser,
        useAuthCode : useAuthCode
    }
}
